import React, { useEffect, useState } from "react";
import ChartCampagne from "../../components/Marketing/ChartCampagne";
import ChartContact from "../../components/Marketing/ChartContact";
import "../../utils/Css/Dashboard.css";
import clientService from "../../services/MarketingService/ClientService";
import DashboardService from "../../services/MarketingService/DashboardService";
import { Link } from "react-router-dom";

function Dashboard() {
  const [data, setData] = useState([]);
  const [erreur, setErreur] = useState(null);
  const [success, setSuccess] = useState(null);
  const [publications, setPublications] = useState(0);
  const [clients, setClients] = useState(0);
  const [offres, setOffres] = useState(0);
  const [campagnes, setCampagnes] = useState(0);

  const StatClient = "Statistiques/Clients";
  const StatFacebook = "Statistiques/Facebook";

  const [hoveredStatFacebook, setHoveredStatFacebook] = useState(false);
  const [hoveredStatClients, setHoveredStatClients] = useState(false);
  const [hoveredStatCampagnes, setHoveredStatCampagnes] = useState(false);

  const handleMouseEnterFacebook = () => {
    setHoveredStatFacebook(true);
  };

  const handleMouseLeaveFacebook = () => {
    setHoveredStatFacebook(false);
  };
  const handleMouseEnterStatClients = () => {
    setHoveredStatClients(true);
  };

  const handleMouseLeaveStatClients = () => {
    setHoveredStatClients(false);
  };

  const handleMouseEnterStatCampagnes = () => {
    setHoveredStatCampagnes(true);
  };

  const handleMouseLeaveStatCampagnes = () => {
    setHoveredStatCampagnes(false);
  };

  useEffect(() => {
    NumberofPublications();
    NumberofClients();
    NumberofCampagnes();
  }, []);

  //afficher number of publications
  const NumberofCampagnes = async () => {
    try {
      const response = await DashboardService.AfficherNumberofCampagnes();
      setCampagnes(response.data);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //afficher number of publications
  const NumberofPublications = async () => {
    try {
      const response = await DashboardService.AfficherNumberofPublications();
      setPublications(response.data);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //afficher number of publications
  const NumberofClients = async () => {
    try {
      const response = await DashboardService.AfficherNumberofClients();
      setClients(response.data);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  const [genreData, setGenreData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await clientService.countgenres(); // assuming countGenre is a function that returns the genre count data
        setGenreData(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, []);

  //data de chart contact
  const dataContact = {
    labels: ["Femme", "Homme"],
    datasets: [
      {
        data: [
          genreData && genreData["Femme"],
          genreData && genreData["Homme"],
        ],
        backgroundColor: ["#FF6384", "#36A2EB"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB"],
      },
    ],
  };

  //Data chart campagne
  const dataCampagne = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "My Data",
        data: [10, 20, 30, 40, 50, 60, 70],
        borderColor: "rgb(255, 99, 132)",
        tension: 0.1,
      },
    ],
  };
  const options = {
    responsive: true,
  };


  return (
    /*   Content Wrapper. Contains page content */

    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="container-fluid">
        {/*  Content Header (Page header) */}
        <div className="content-header">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Dashboard</h1>
            </div>

            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Marketing</a>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>

        {/* /.content-header */}

        {/* /* Main content */}
        <section className="content">
          {/*  row*/}
          <div className="row">
            <div className="col-lg-4 col-6">
              <div
                className="card mb-4 small-box"
                style={{ backgroundColor: "#939393" }}
              >
                <div className="inner" style={{ color: "white" }}>
                  <h3>{campagnes}</h3>
                  <p>Campagnes</p>
                </div>
                <div className="icon">
                  <i className="nav-icon fas fa-bullhorn"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-6">
              <div className="card mb-4 small-box bg-secondary">
                <div className="inner" style={{ color: "white" }}>
                  <h3>{publications}</h3>
                  <p>Publications</p>
                </div>
                <div className="icon">
                  <i className="nav-icon fas fas fa-newspaper"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-6">
              <div
                className="card mb-4 small-box "
                style={{ backgroundColor: "#384454" }}
              >
                <div className="inner" style={{ color: "white" }}>
                  <h3>{clients}</h3>
                  <p>Contacts</p>
                </div>
                <div className="icon">
                  <i className="nav-icon fas fa-address-card"></i>
                </div>
              </div>
            </div>

            {/* <div className="col-lg-3 col-6">
              <div
                className="card mb-4 small-box"
                style={{ backgroundColor: "#317AC1" }}
              >
                <div className="inner" style={{ color: "white" }}>
                  <h3>10</h3>
                  <p>Offres</p>
                </div>
                <div className="icon">
                  <i className="nav-icon fas fa-regular fa-gift"></i>
                </div>
              </div>
            </div> */}
          </div>
          {/*end of row*/}
          {/* row*/}
          <div class="row">
            {/*card*/}
            <div class="col">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">Statistiques de Contacts </h3>
                  <div className="card-tools">
                    <Link to={StatClient}>
                      <button
                        type="button"
                        className="btn btn-tool"
                        onMouseEnter={handleMouseEnterStatClients}
                        onMouseLeave={handleMouseLeaveStatClients}
                      >
                        {hoveredStatClients ? (
                          <>
                            <i
                              className="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i>
                            <i
                              className="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i>
                          </>
                        ) : (
                          <i
                            className="fa fa-chevron-right"
                            aria-hidden="true"
                          ></i>
                        )}
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="card-body d-flex align-items-center justify-content-center">
                  <ChartContact data={dataContact} />
                </div>
              </div>
            </div>
            {/*end of card*/}
            {/*card*/}
            <div class="col">
              <div className="card card-dark">
                <div className="card-header">
                  <strong>Statistiques</strong>
                  <span className="small ms-1"> | facebook</span>
                  <div className="card-tools">
                    <Link to={StatFacebook}>
                      <button
                        type="button"
                        className="btn btn-tool"
                        onMouseEnter={handleMouseEnterFacebook}
                        onMouseLeave={handleMouseLeaveFacebook}
                      >
                        {hoveredStatFacebook ? (
                          <>
                            <i
                              className="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i>
                            <i
                              className="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i>
                          </>
                        ) : (
                          <i
                            className="fa fa-chevron-right"
                            aria-hidden="true"
                          ></i>
                        )}
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <ChartCampagne data={dataCampagne} options={options} />
                </div>  
              </div>
            </div>
            {/*end of card*/}
          </div>
          {/*end of row*/}
        </section>
      </div>
    </div>
  );
}

export default Dashboard;
